import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { LogOut, LayoutGrid, BarChart3 } from "lucide-react";

export default function Navbar() {
    const { user, logout } = useAuth();
    const location = useLocation();
    if (!user) return null;
    const isAdmin = user.role === "admin";

    const linkCls = (path) =>
        `flex items-center gap-2 px-3 py-2 text-sm border transition-colors ${
            location.pathname === path
                ? "border-black bg-black text-white"
                : "border-transparent hover:border-black/30"
        }`;

    return (
        <header className="bg-white border-b border-black/10 sticky top-0 z-40" data-testid="navbar">
            <div className="px-6 lg:px-10 py-4 flex items-center justify-between gap-4">
                <div className="flex items-center gap-6">
                    <Link to="/board" className="flex items-center gap-3">
                        <div className="w-7 h-7 bg-black" />
                        <span className="font-display text-lg">Pipeline</span>
                    </Link>
                    <nav className="hidden md:flex items-center gap-1">
                        <Link to="/board" className={linkCls("/board")} data-testid="nav-board">
                            <LayoutGrid className="w-4 h-4" />
                            Tablero
                        </Link>
                        {isAdmin && (
                            <Link
                                to="/admin"
                                className={linkCls("/admin")}
                                data-testid="nav-admin"
                            >
                                <BarChart3 className="w-4 h-4" />
                                Panel Admin
                            </Link>
                        )}
                    </nav>
                </div>

                <div className="flex items-center gap-4">
                    <div className="hidden sm:flex flex-col items-end leading-tight">
                        <span className="text-sm font-medium" data-testid="user-name">
                            {user.name}
                        </span>
                        <span className="label-eyebrow text-neutral-500" data-testid="user-role">
                            {isAdmin ? "ADMINISTRADOR" : "VENDEDOR"}
                        </span>
                    </div>
                    {user.picture ? (
                        <img
                            src={user.picture}
                            alt={user.name}
                            className="w-9 h-9 border border-black/20 object-cover"
                            referrerPolicy="no-referrer"
                        />
                    ) : (
                        <div className="w-9 h-9 bg-neutral-200 border border-black/20 flex items-center justify-center text-xs">
                            {user.name?.[0]?.toUpperCase()}
                        </div>
                    )}
                    <button
                        data-testid="logout-button"
                        onClick={logout}
                        className="p-2 border border-black/20 hover:border-black transition-colors"
                        title="Salir"
                    >
                        <LogOut className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </header>
    );
}
